import Payment from "payment";
import { PDFDocument } from "pdf-lib";
import CryptoJS from "crypto-js";

const clearNumber = (value = "") => {
  return value.replace(/\D+/g, "");
};

export const parseJwt = (token: any) => {
  if (token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
  return {};
};

export const getUserIdFromStorage = (): string | null => {
  try {
    const authData = localStorage.getItem('mamiVendorXAuth');

    if (authData) {
      const parsed = JSON.parse(authData);
      return parsed.userProfile?.id || null;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const formatCreditCardNumber = (value: any) => {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case "amex":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`;
      break;
    case "dinersclub":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
};

export const formatCVC = (value?: any, prevValue?: any, allValues?: any) => {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues?.number) {
    const issuer = Payment.fns.cardType(allValues?.number);
    maxLength = issuer === "amex" ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
};

export const formatExpirationDate = (value?: any) => {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
};

export const handleRequestErrors = (error: any) => {
  if (error !== undefined && error !== null && error !== "") {
    console.log("error.response", error)
    if (typeof error.response === "object") {
      if (error.response && error.response?.data?.error_detail) {
        return error.response.data.error_detail;
      }
      if (error.response && error.response?.data?.error_description) {
        return error.response.data.error_description;
      } else {
        if (error.response?.data?.detail) {
          return error.response?.data?.detail;
        } else if (error.response?.data?.error) {
          return error.response.data.error;
        } else {
          return "The service is presently unreachable. Please try again later";
        }
      }
    }
    if (typeof error?.data) {
      if (error?.data?.error_detail) {
        return error?.data?.error_detail;
      }
      if (error?.data?.error_description) {
        return error?.data?.error_description;
      } else {
        if (error?.data?.detail) {
          return error?.data?.detail;
        } else if (error?.data?.error) {
          return error?.data?.error;
        } else {
          return "The service is presently unreachable. Please try again later";
        }
      }
    }

    if (error.toString() === "Error: Network Error") {
      return "Please check your network and try again";
    }

    return "An error occured";
  }

  return "Something went wrong. Please try again";
};

export const modelStateErrorHandler = (error: any) => {
  try {
    if (error?.response) {
      if ("errors" in error.response.data && error.response?.data?.title) {
        if (
          "errors" in error.response.data &&
          error.response.data.title
            .toLowerCase()
            .indexOf("one or more validation errors occurred.") > -1
        ) {
          let message = "";
          for (let key in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(key)) {
              if (Object.keys(error.response.data.errors).length > 1) {
                message += error.response.data.errors[key] + "\n";
              } else {
                message += error.response.data.errors[key];
              }
            }
          }
          return message;
        }
      }
    }
  } catch (err) {
    return "Error : Something went wrong";
  }
};

export const handleError = (error: any) => {
  var message = "";
  if (error.response) {
    if (error.response.status >= 500 && error.response.status < 600) {
      message = "something went wrong, try again please.";
    } else {
      message = error.response.data.message || error.response.data.Message;
    }
  } else if (error.request) {
    message = error.message;
  } else {
    message = error.message;
  }
  return message;
};

export const getDateFromISOOne = ({
  date,
  returnTime,
  hasDivider,
}: {
  date: any;
  returnTime?: boolean;
  hasDivider?: boolean;
}) => {
  let toUse = new Date(date),
    year = toUse.getFullYear(),
    month: any = toUse.getMonth() + 1,
    dt: any = toUse.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  let divider = hasDivider ? "/" : "-";
  let convertedDate = `${dt}${divider}${month}${divider}${year}`;
  let convertedTime = "";
  if (returnTime === true && date.indexOf("T") === -1) {
    convertedTime = date.replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1");
    return convertedTime;
  }
  if (returnTime === true && date.indexOf("T") > -1) {
    convertedTime = date.replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1");

    let convertedDateAndTime = `${convertedDate} ${convertedTime}`;
    return convertedDateAndTime;
  }

  return convertedDate;
};

export const getDateFromISO = ({
  date,
  returnTime,
}: {
  date: any;
  returnTime?: boolean;
}) => {
  let toUse = new Date(date),
    year = toUse.getFullYear(),
    month: any = toUse.getMonth() + 1,
    dt: any = toUse.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  const now = toUse
    .toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();

  let monthtxt = toUse.toLocaleString("default", { month: "short" });
  let convertedDate = `${monthtxt} ${dt}, ${year}`;

  let convertedTime = "";

  if (
    returnTime === true &&
    (date.indexOf("T") > -1 || date.indexOf(" ") > -1)
  ) {
    let convertedDateAndTime = `${convertedDate} ${now}`;
    return convertedDateAndTime;
  } else {
    if (returnTime === true && date.indexOf("T") === -1) {
      convertedTime = date.replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1");
      return convertedTime;
    }
  }

  return convertedDate;
};

export const accountNumber = (accountNum: string, maxChars: string) => {
  let filteredNum = accountNum.replace(/\D/g, "");
  let maxNoOfChars =
    maxChars !== null && maxChars !== undefined ? parseInt(maxChars) : 10;
  if (filteredNum.toString().length <= maxNoOfChars) {
    return filteredNum;
  } else {
    return filteredNum.toString().substr(0, maxNoOfChars);
  }
};

export const noWhiteSpaces = (value: string) => {
  let filteredValue = value.trim().replace(/\s/g, "");
  return filteredValue;
};

export const decimalNumber = (number: string) => {
  if (number) {
    const fixedNumber = Number.parseFloat(number).toFixed(2);
    return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return "";
};

export const allowNumbersOnly = (numbers: string, maxLength?: any) => {
  if (numbers !== undefined && numbers !== null) {
    let filteredNum = numbers.replace(/\D/g, "");

    if (typeof maxLength === "number") {
      if (filteredNum.toString().length <= maxLength) {
        return filteredNum;
      } else {
        return filteredNum.toString().substring(0, maxLength);
      }
    } else {
      return filteredNum;
    }
  } else {
    return null;
  }
};

export const numberWithoutDecimals = (amount: string) => {
  let amountFiltered, splittedDecimal, amountTemp;
  amount = amount.toString().replace(/-\D/g, "");

  amountFiltered = amount.toString().replace(/,/g, "");

  if ((amountFiltered.match(/\./g) || []).length === 1) {
    if (amountFiltered.indexOf(".") > 0) {
      splittedDecimal = amountFiltered.trim().split(".");

      if (splittedDecimal[1].indexOf(".") > -1) {
        splittedDecimal[1] = splittedDecimal[1].replace(/./g, "");
      }

      if (splittedDecimal[0].indexOf(".") > -1) {
        splittedDecimal[0] = splittedDecimal[0].replace(/./g, "");
      }

      if (splittedDecimal[1].length > 2) {
        splittedDecimal[1] = splittedDecimal[1].substring(2, 0);
      }

      amountTemp = splittedDecimal[0]
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      return `${amountTemp}.${splittedDecimal[1]}`;
    }
  }
  if ((amountFiltered.match(/\./g) || []).length > 1) {
    var numberParts: string | string[] = amountFiltered.split(".");
    numberParts =
      numberParts.slice(0, -1).join("") + "." + numberParts.slice(-1);

    return numberParts.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  return amountFiltered.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const numberWithCommas = (amount: string, isDecimal?: boolean) => {
  if (amount !== "") {
    let amountFiltered, splittedDecimal, amountTemp;
    amount = amount.toString().replace(/[^-?^0-9.,]/g, "");

    amountFiltered = amount.toString().replace(/,/g, "");

    if ((amountFiltered.match(/\./g) || []).length === 1) {
      if (amountFiltered.indexOf(".") > 0) {
        splittedDecimal = amountFiltered.trim().split(".");

        if (splittedDecimal[1].indexOf(".") > -1) {
          splittedDecimal[1] = splittedDecimal[1].replace(/./g, "");
        }

        if (splittedDecimal[0].indexOf(".") > -1) {
          splittedDecimal[0] = splittedDecimal[0].replace(/./g, "");
        }

        if (splittedDecimal[1].length > 2) {
          splittedDecimal[1] = splittedDecimal[1].substring(2, 0);
        }

        if (splittedDecimal[1].length < 2 && isDecimal === true) {
          splittedDecimal[1] = splittedDecimal[1] + "0";
        }

        amountTemp = splittedDecimal[0]
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return `${amountTemp}.${splittedDecimal[1]}`;
      }
    }

    if ((amountFiltered.match(/\./g) || []).length > 1) {
      var numberParts: string | string[] = amountFiltered.split(".");
      numberParts =
        numberParts.slice(0, -1).join("") + "." + numberParts.slice(-1);

      return numberParts.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }

    if (amountFiltered.indexOf(".") === -1 && isDecimal === true) {
      amountFiltered = amountFiltered + ".00";
    }

    return amountFiltered.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  if (amount === "") {
    return "";
  }
};

export const getDateInfo = (dateValue: string, returnTime: string): string => {
  let dateString = dateValue.split("T")[0];
  dateString = new Date(dateString).toUTCString();

  dateString = dateString.split("00").slice(0, 3).join(" ").replace(/:/g, "");
  return dateString;
};

export const printBase64ImageAsPDF = async (base64Image: string) => {
  try {
    const imageData = base64Image.startsWith("data:image")
      ? base64Image
      : `data:image/png;base64,${base64Image}`;

    const byteCharacters = atob(imageData.split(",")[1]);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595.28, 841.89]);

    const image = await pdfDoc.embedPng(byteArray);

    const scaleFactor = 0.5;
    const { width, height } = image.scale(scaleFactor);

    const x = (page.getWidth() - width) / 2;
    const y = (page.getHeight() - height) / 2;

    page.drawImage(image, { x, y, width, height });

    const pdfBytes = await pdfDoc.save();

    const ab = pdfBytes.buffer.slice(
      pdfBytes.byteOffset,
      pdfBytes.byteOffset + pdfBytes.byteLength
    );
    const blob = new Blob([ab], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = "ORDER_SHIPEMENT_LABEL.pdf";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(blobUrl);
  } catch (error) { }
};

const SECRET_KEY = process.env.REACT_APP_ENCODING_KEY!;

export const saveCredentials = (email: string, password: string) => {
  const data = JSON.stringify({ email, password });
  const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  localStorage.setItem("user_credentials", encrypted);
};

export const getCredentials = () => {
  const encrypted = localStorage.getItem("user_credentials");
  if (!encrypted) return null;

  const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);

  return JSON.parse(decrypted);
};

export const extractEmail = (queryString: string) => {
  const params = new URLSearchParams(queryString);

  const email = params.get("username");

  return email;
};

type Address = {
  suiteNumber?: string | null;
  city?: string | null;
  province?: string | null;
  country?: string | null;
  postalCode?: string | null;
  streetAddress?: string | null;
};


export const formatAddress = (address: Address | null): string => {
  if (!address) return "No address available.";

  let suiteNumber = "";
  let street = "";
  let city = "";
  let province = "";
  let postalCode = "";
  let country = "";

  suiteNumber =
    address.suiteNumber !== null && address.suiteNumber !== undefined
      ? String(address.suiteNumber).trim()
      : "";
  street =
    address.streetAddress !== null && address.streetAddress !== undefined
      ? String(address.streetAddress).trim()
      : "";
  city =
    address.city !== null && address.city !== undefined
      ? String(address.city).trim()
      : "";
  province =
    address.province !== null && address.province !== undefined
      ? String(address.province).trim()
      : "";
  postalCode =
    address.postalCode !== null && address.postalCode !== undefined
      ? String(address.postalCode).trim()
      : "";
  country =
    address.country !== null && address.country !== undefined
      ? String(address.country).trim()
      : "";

  const countryLower = country.toLowerCase();
  const streetHasCountry = street.toLowerCase().includes(countryLower);

  if (streetHasCountry) {
    const regex = new RegExp(`\\b${country}\\b`, "i");
    street = street.replace(regex, "").replace(/\s+/g, " ").trim();
  }

  if ("addressLine1" in address && suiteNumber) {
    street = `${suiteNumber || "23"}-${street}`;
  }

  const parts = [street, city, province, postalCode, country]
    .filter(Boolean)
    .join(", ")
    .replace(/\s+/g, " ")
    .replace(/,\s*,/g, ",")
    .replace(/,\s*$/, "")
    .trim();

  return parts + ".";
};
